<template>
  <div>
    <MonthlyField
      ref="otherPeriodField"
      type="monthly"
      :disabled="false"
      :min="min"
      :max="max"
      @cancelDateSelected="cancelDateSelected"
      @applyDateSelected="applyDateSelected($event)"
    ></MonthlyField>
  </div>
</template>

<script>
//import moment from 'moment';
import MonthlyField from "./MonthlyField";
export default
{
  props:['min','max'],
  name: 'MonthlyFilter',
  components: {MonthlyField},
  data:()=>({
    type: undefined,
    period: undefined,
    beforeDate: undefined,
    currentDate: undefined
  }),
  computed:{
    //
  },
  methods:{
    cancelDateSelected(){
      this.$refs.otherPeriodField.backOldDateValue(this.currentDate);
    },
    applyDateSelected(date){
      this.beforeDate = this.currentDate;
      this.currentDate = date;
      this.$emit('applyPeriod', this.currentDate);
    }
  }
}
</script>

<style scoped>
</style>
